import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Heart } from "lucide-react";
import { HELLOASSO_URL } from "../config";
import { useLang } from "../LanguageContext";

// Renders a donation call-to-action. Opens the on-site donation page (/don, which
// embeds the HelloAsso form) when configured, otherwise scrolls to the
// "Soutenir l'école" section on /s-engager.
export function DonateButton({
  className = "btn-primary",
  label,
  testId = "donate-btn",
  withIcon = true,
  onClick,
}) {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const text = label || t("common.donate");
  const inner = (
    <>
      {withIcon && <Heart size={16} />} {text}
    </>
  );

  if (HELLOASSO_URL) {
    return (
      <Link to="/don" className={className} data-testid={testId} onClick={onClick}>
        {inner}
      </Link>
    );
  }

  const scrollToSoutenir = () => {
    const el = document.getElementById("soutenir");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) onClick();
    if (location.pathname === "/s-engager") {
      scrollToSoutenir();
    } else {
      navigate("/s-engager#soutenir");
      setTimeout(scrollToSoutenir, 150);
    }
  };

  return (
    <a href="/s-engager#soutenir" className={className} data-testid={testId} onClick={handleClick}>
      {inner}
    </a>
  );
}
